export const BAC_PERIODS = ['yesterday', 'lastWeek', 'lastMonth', 'lastYear', 'custom'];

export const normalizeBacPeriod = value => BAC_PERIODS.includes(value) ? value : 'yesterday';

export const bacMaxDate = (now = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Guatemala', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(now);
  const part = type => parts.find(item => item.type === type).value;
  // UTC is used only for calendar arithmetic, never to parse a selected date.
  const calendar = new Date(Date.UTC(+part('year'), +part('month') - 1, +part('day') - 1));
  return calendar.toISOString().slice(0, 10);
};

const isCalendarDate = value => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
  const [year, month, day] = value.split('-').map(Number);
  const days = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return year >= 1000 && month >= 1 && month <= 12 && day >= 1 && day <= days;
};

export const validateBacPeriod = (value, maxDate = bacMaxDate()) => {
  if (!BAC_PERIODS.includes(value.periodKeyword)) return 'Seleccione un período BAC válido.';
  if (value.periodKeyword !== 'custom') return '';
  if (!isCalendarDate(value.fromDate) || !isCalendarDate(value.toDate)) return 'Seleccione ambas fechas del rango BAC.';
  if (value.fromDate > value.toDate) return 'La fecha inicial debe ser menor o igual a la fecha final.';
  if (value.toDate > maxDate) return `BAC solo permite fechas hasta ${maxDate} (ayer en America/Guatemala).`;
  return '';
};

export const buildBacPeriodPayload = (value, keyword = 'periodKeyword') =>
  value.periodKeyword === 'custom'
    ? { fromDate: value.fromDate, toDate: value.toDate }
    : { [keyword]: normalizeBacPeriod(value.periodKeyword) };
